/**
 * EmptyState — Estado vacío con call-to-action.
 * Reemplaza los "No hay X" planos por algo accionable.
 *
 * Props:
 *   icon, title, description?, ctaLabel?, onCta?, size? ('sm'|'md'|'lg')
 */
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export default function EmptyState({
  icon,
  title,
  description,
  ctaLabel,
  onCta,
  ctaIcon,
  size = 'md',
}) {
  const padding = { sm: 3, md: 5, lg: 7 }[size];
  const iconSize = { sm: 36, md: 56, lg: 72 }[size];

  return (
    <Box sx={{
      py: padding, px: 2, textAlign: 'center',
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1,
    }}>
      {icon && (
        <Box sx={{
          width: iconSize + 24, height: iconSize + 24, borderRadius: '50%',
          bgcolor: '#f1f5f9', color: '#94a3b8',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          mb: 1,
          '& svg': { fontSize: iconSize },
        }}>
          {icon}
        </Box>
      )}
      <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#0f172a' }}>
        {title}
      </Typography>
      {description && (
        <Typography sx={{ fontSize: 13, color: '#64748b', maxWidth: 380 }}>
          {description}
        </Typography>
      )}
      {ctaLabel && onCta && (
        <Button variant="contained" disableElevation onClick={onCta}
          startIcon={ctaIcon || <AddIcon />}
          sx={{
            mt: 1.5, textTransform: 'none', fontWeight: 600,
            background: 'linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)',
            '&:hover': { background: 'linear-gradient(135deg, #0f766e 0%, #0d9488 100%)' },
          }}>
          {ctaLabel}
        </Button>
      )}
    </Box>
  );
}
